import { computed, ComputedRef, Reactive, reactive, Ref, ref } from "vue";
import { useStore } from "vuex";

export const key = Symbol("homeButtonControls");

export interface ClickCoordinates {
  x: number;
  y: number;
}

export interface HomeButtonControlsApi {
  show: ComputedRef<boolean>;
  editHomeButton: (id: string, coordinates: Reactive<ClickCoordinates>) => void;
  homeButtonId: Ref<string | null>;
  clickCoordinates: Reactive<ClickCoordinates>;
}

const homeButtonId: Ref<string | null> = ref(null);
const clickCoordinates = reactive({ x: 0, y: 0 });

export default function createData(): HomeButtonControlsApi {
  const store = useStore();
  return {
    show: computed(() => store.getters.showCMS),
    editHomeButton(id, coordinates) {
      homeButtonId.value = id;
      clickCoordinates.x = coordinates.x;
      clickCoordinates.y = coordinates.y;
    },
    homeButtonId,
    clickCoordinates,
  };
}

const injectError = `Inject has failed for HomeButtonControlsApi`;

export const defaultApi: HomeButtonControlsApi = {
  show: computed(() => false),
  editHomeButton: () => console.error(injectError),
  homeButtonId: ref(null),
  clickCoordinates: reactive({ x: 0, y: 0 }),
};

export const storybookApi: HomeButtonControlsApi = {
  show: computed(() => false),
  editHomeButton(id, coordinates) {
    alert(
      `editing home button. id: ${id} click coordinates: ${JSON.stringify(
        coordinates
      )}`
    );
  },
  homeButtonId: ref(null),
  clickCoordinates: reactive({ x: 0, y: 0 }),
};
